/* Changes Oscar 22-10: el movimiento lo hace una animación CSS (tarjeta gráfica), no JS en cada fotograma.
   Este JS solo mide el ancho del bucle (--ticket-distance) y la altura del recuadro girado, y pausa la animación fuera de pantalla. */
(function () {
  function initBenefitsTicketBar(container) {
    if (!container) return;
    const spacer = container.querySelector('.benefits-ticket-bar__spacer');
    const rotator = container.querySelector('.benefits-ticket-bar__rotator');
    const track = container.querySelector('.benefits-ticket-bar__track');
    const originalItems = container.querySelector('.benefits-ticket-bar__items--original');
    if (!spacer || !rotator || !track || !originalItems) return;
    if (container.dataset.ticketInitialized === 'true') return;
    container.dataset.ticketInitialized = 'true';

    function calculate() {
      const styles = getComputedStyle(container);
      const trackGap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const loopWidth = originalItems.offsetWidth + trackGap;
      container.style.setProperty('--ticket-distance', loopWidth + 'px');
      const angle = parseFloat(styles.getPropertyValue('--ticket-angle')) || 0;
      const width = rotator.offsetWidth;
      const height = rotator.offsetHeight;
      const radians = Math.abs(angle) * Math.PI / 180;
      const rotatedHeight = Math.abs(height * Math.cos(radians)) + Math.abs(width * Math.sin(radians));
      container.style.height = rotatedHeight + 'px';
      spacer.style.height = rotatedHeight + 'px';
      if (loopWidth > 0) container.setAttribute('data-ticket-css', '');
    }

    let pending = false;
    function refresh() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; calculate(); });
    }

    calculate();
    window.addEventListener('load', refresh);
    let resizeTimeout;
    window.addEventListener('resize', function () { clearTimeout(resizeTimeout); resizeTimeout = setTimeout(refresh, 100); });
    if (window.ResizeObserver) {
      const observer = new ResizeObserver(refresh);
      observer.observe(originalItems);
      observer.observe(rotator);
    }
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { container.classList.toggle('is-offscreen', !entry.isIntersecting); });
      }).observe(container);
    }
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:block:select', refresh);
      document.addEventListener('shopify:block:deselect', refresh);
    }
  }

  function initAllBenefitsTicketBars() {
    document.querySelectorAll('.benefits-ticket-bar').forEach(initBenefitsTicketBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllBenefitsTicketBars);
  } else {
    initAllBenefitsTicketBars();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const container = event.target.querySelector('.benefits-ticket-bar');
    if (container) {
      container.removeAttribute('data-ticket-initialized');
      initBenefitsTicketBar(container);
    }
  });
})();
